import { z } from 'zod'

import type { RequestService } from '../request'

export function feedbackApiFactory(requestService: RequestService) {
  /** Submit feedback on an app */
  async function submit(email: string, feedback: string) {
    return await requestService.request({
      url: 'core/feedback',
      method: 'post',
      data: {
        email,
        feedback,
      },
      schema: z.null(),
    })
  }

  return {
    submit,
  }
}
